<template>
    <b-card no-body>

        <b-modal id="create" title='Oluştur' no-close-on-esc no-close-on-backdrop>
            <user-excuse-create v-model="userExcuse"></user-excuse-create>
            <template #modal-footer><v-executer :loading="loading" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { UserExcuseApi } from '@/api/user-excuse'
import UserExcuseCreate from './components/UserExcuseCreate.vue'
export default {
    components:{
        BCard,
        UserExcuseCreate
    },
    data(){
        return{
            loading:false,
            fields:[
                {name:'Onaylandı mı?',key:'Approved',tdClass:'text-nowrap',sortable:true, thClass:'w-5'},
                {name:'Ad Soyad',key:'FullName',tdClass:'text-nowrap', sortable:true,sortKey:'User.FullName', thClass:'w-35'},
                {name:'İzin Türü',key:'ExcuseType',tdClass:'text-nowrap',sortable:true,sortKey:'UserExcuseType.Name', thClass:'w-30'},
                {name:'Başlangıç Zamanı',key:'StartDate',tdClass:'text-nowrap',sortable:true, thClass:'w-20'},
                {name:'Bitiş Zamanı',key:'EndDate',tdClass:'text-nowrap',sortable:true, thClass:'w-20'},
                
                
            ],
            buttons:[
                { text:"İzni Onayla",key:"approve",icon:"CheckIcon",variant:"success",action:this.approve,condition:(item) => !item.Approved },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete,condition:(item) => !item.Approved },
            ],
            userExcuse:{
                Id:null,
                UserId:null,
                UserExcuseTypeId:null,
                StartDate:null,
                EndDate:null,
                Approved:null
            }
        }
    },
    methods:{
        clearForm(){
            this.userExcuse.Id = null
            this.userExcuse.UserId = null
            this.userExcuse.UserExcuseTypeId = null
            this.userExcuse.StartDate = null
            this.userExcuse.EndDate = null
            this.userExcuse.Approved = null
        },
        provider(data){
            return UserExcuseApi.Table(data)
        },
        createNew(){
            this.clearForm()
            this.$showModal('create')
        },
        createOrUpdate(){
            this.loading = true
            UserExcuseApi.Create(this.userExcuse).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.FullName} kişisine ait izni silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    UserExcuseApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        approve(item){
            this.$confirm('Onaylamak istediğinize emin misiniz?',`Bu işlem ${item.FullName} kişisine ait izni onaylayacaktır ve geri alınamaz.`).then(result=>{
                if(result){
                    UserExcuseApi.Approve(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>